import { initLightIcons } from "./light";
import { initRegularIcons } from "./regular";
import { initSharpIcons } from "./sharp";
import { initSolidIcons } from "./solid";
import { initThinIcons } from "./thin";

export const initIcons = () => {
  initLightIcons();
  initRegularIcons();
  initSolidIcons();
  initThinIcons();
  initSharpIcons();
};
